import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class VideoPlayerController extends BridgeComponent {
  static component = "video-player";

  static values = {
    timestamp: Number
  };

  async connect() {
    let feedItemUrl = this.element.getAttribute("data-feed-item-url");
    let hlsPlaylist = this.element.getAttribute("data-playlist-url");
    let itemId = this.element.getAttribute('data-item-id');
    let itemType = this.element.getAttribute('data-item-type');
    let title = this.element.getAttribute('data-title');

    const timestamp = await this.getTimestamp(itemType, itemId);

    if (!this.element.isConnected) return;

    let originalUrl = this.element.getAttribute("data-original-url");

    this.send("connect", {
      feedItemUrl: feedItemUrl,
      hlsPlaylist: hlsPlaylist,
      originalUrl: originalUrl,
      // Sent as a number, not the raw getAttribute string: Android's ConnectData.itemId is
      // typed Long and kotlinx.serialization's default Json isn't lenient about a quoted
      // numeric string there, so a bare string here would fail JSON decode and silently
      // drop the whole connect payload (including the timestamp below) on Android.
      itemId: itemId != null ? Number(itemId) : itemId,
      itemType: itemType,
      title: title,
      timestamp: timestamp,
    });
  }

  disconnect() {
    // Disonnect is key here because we want to hide video players when the page unloads. It's cleaner to 
    // do this from the rails side vs. the app since videos can be hosted in different contexts.
    this.send("disconnect");
  }

  // Mirrors the resume logic in media/video_player_controller.js#readyToPlay: prefer an explicit
  // ?timestamp (e.g. from PiP hand-off), otherwise fall back to the locally saved playback position.
  async getTimestamp(itemType, itemId) {
    if (this.hasTimestampValue && this.timestampValue > 0) {
      return this.timestampValue;
    }

    if (!window.playbackDb) return 0;

    const playbackData = await window.playbackDb.getPlaybackData(itemType, itemId);
    return playbackData ? playbackData.currentTime : 0;
  }
}
